// src/components/KanbanBoard.js
import React, { useState, useEffect } from "react";
import { getProjects, updateProject } from "../../services/api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Container, Col, Card } from "react-bootstrap";

const KanbanBoard = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await getProjects();
        if (response) {
          setProjects(response);
        } else {
          setProjects([]);
        }
      } catch (error) {
        setError("Error al obtener proyectos");
        console.error("Error al obtener proyectos", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const handleDragEnd = async (result) => {
    console.log("result", result);
    const { destination, source, draggableId } = result;

    if (!destination) return;

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const updatedProjects = Array.from(projects);
    const [movedProject] = updatedProjects.splice(source.index, 1);
    movedProject.estado = destination.droppableId;
    updatedProjects.splice(destination.index, 0, movedProject);

    setProjects(updatedProjects);
    console.log("updatedProjects: ", updatedProjects);

    try {
      await updateProject(movedProject.proyectos_id, {
        estado: movedProject.estado,
      });
    } catch (error) {
      console.error("Error al actualizar el estado del proyecto", error);
    }
  };
  console.log("projects: ", projects);
  const getStatusProjects = (status) =>
    projects.filter((project) => project.estado === status);

  console.log("getStatus:", getStatusProjects);

  const statuses = ["Nuevo", "En progreso", "Finalizado", "En espera"];

  if (loading) {
    return <p>Cargando...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="all-projects" direction="horizontal">
        {(provided) => (
          <Container
            ref={provided.innerRef}
            {...provided.droppableProps}
            fluid
            style={{ display: "flex", overflowX: "auto" }}
          >
            {statuses.map((status, index) => (
              <Droppable key={status} droppableId={status}>
                {(provided) => (
                  <Col
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                      margin: "0 10px",
                      padding: "10px",
                      background: "#f4f4f4",
                      borderRadius: "4px",
                    }}
                  >
                    <h3>{status}</h3>
                    {getStatusProjects(status).map((project, index) => (
                      <Draggable
                        key={project.proyectos_id.toString()}
                        draggableId={project.proyectos_id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <Card
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              marginBottom: "10px",
                            }}
                          >
                            <Card.Body>{project.nombre}</Card.Body>
                          </Card>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Col>
                )}
              </Droppable>
            ))}
            {provided.placeholder}
          </Container>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default KanbanBoard;
